import { createReducer, on } from '@ngrx/store';
import { User, UserAccount, InstallStatus } from '../../models/user.model';
import { AuthActions } from './auth.actions';

export interface AuthState {
  isSignedIn: boolean;
  user: User | null;
  installState: Record<string, InstallStatus>;
  selectedAccount: UserAccount | null;
  contractsByAccount: Record<string, { id: string; name: string }[]>;
  selectedContractId: string | null;
  accessToken: string | null;
  idToken: string | null;
  refreshToken: string | null;
  /** Unix timestamp (seconds) when the access token expires — same as JWT exp claim. */
  tokenExpiresAt: number | null;
}

const initialState: AuthState = {
  isSignedIn: false,
  user: null,
  installState: {},
  selectedAccount: null,
  contractsByAccount: {},
  selectedContractId: null,
  accessToken: null,
  idToken: null,
  refreshToken: null,
  tokenExpiresAt: null,
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.signInSuccess, (state, { user }) => ({
    ...state,
    isSignedIn: true,
    user,
  })),
  on(AuthActions.tokensStored, (state, { accessToken, idToken, refreshToken, tokenExpiresAt }) => ({
    ...state,
    accessToken,
    idToken,
    refreshToken,
    tokenExpiresAt,
  })),
  on(AuthActions.signOut, () => initialState),
  on(AuthActions.activateSandbox, (state, { productId }) => ({
    ...state,
    installState: { ...state.installState, [productId]: 'sandbox' },
  })),
  on(AuthActions.installComplete, (state, { productId }) => ({
    ...state,
    installState: { ...state.installState, [productId]: 'installed' },
  })),
  on(AuthActions.userContextLoaded, (state, { account }) => ({
    ...state,
    selectedAccount: account,
  })),
  on(AuthActions.userContextChanged, (state, { account }) => ({
    ...state,
    selectedAccount: account,
    selectedContractId: null,
  })),
  on(AuthActions.accountContractsLoaded, (state, { contractsByAccount }) => ({
    ...state,
    contractsByAccount,
  })),
  on(AuthActions.contractSelected, (state, { contractId }) => ({
    ...state,
    selectedContractId: contractId,
  })),
);
